import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalModule } from 'ngx-bootstrap/modal';
import { JobProfileModule } from 'src/app/pages/mission-control-page/job-profile-page/job-profile/job-profile.module';
import { UploadReqJobProfileModalComponent } from './upload-req-job-profile-modal.component';

@NgModule({
  declarations: [UploadReqJobProfileModalComponent],
  imports: [
    CommonModule,
    ModalModule.forRoot(),
    JobProfileModule
  ],
  exports: [UploadReqJobProfileModalComponent],
  entryComponents: [UploadReqJobProfileModalComponent]
})
export class UploadReqJobProfileModalModule { }
